import Service from "../../../Services/index";

const WorkScheduleEmployee = {
    namespaced: true,
    state: {
        workScheduleList: [],
        work_schedule: {
            id: "",
            employee: "",
            leave_type: "",
            start_date: "",
            end_date: "",
            status: "",
            time: "",
            leave_time: "",
            employee_id: '',
            leave_time_type: "",
            can_recive: "",
        },
        work_schedule_employee: [],
        search: {
            employee_type: "",
            position: [],
            employee: [],
            date: [],
            active: ''
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        vocationDay: 0,
        vocation_day_year: 0
    },
    mutations: {
        GET_WORK_SCHEDULE_EMPLOYEE: (state, res) => {
            state.workScheduleList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_WORK_SCHEDULE_BY_ID: (state, res) => {
            //console.log(res);
            state.work_schedule = res;
        },
        GET_EMPLOYEE: (state, res) => {
            state.employee = res;
        },
        CLEAR_DATA: (state, employee) => {
            state.work_schedule = {
                id: "",
                employee: employee,
                leave_type: "",
                start_date: "",
                end_date: "",
                status: "",
                time: "",
                leave_time_type: "",
            }
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                employee_type: "",
                type_id: "",
                position: [],
                position_id: "",
                employee: [],
                date: [],
                active: ''
            }
        },
        GET_WORK_SCHEDULE_BY_EMPLOYEE: (state, res) => {
            state.work_schedule_employee = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_VOCATION_DAY: (state, res) => {
            state.vocationDay = res[0];
            state.vocation_day_year = res[1];
        }
    },
    actions: {
        setWorkScheduleList({commit}, page = 1) {
            return Service.WorkScheduleEmployee.getWorkScheduleEmployee(page).then(response => {
                commit("GET_WORK_SCHEDULE_EMPLOYEE", response);
            });
        },
        showWorkScheduleById({commit}, id) {
            return Service.WorkScheduleEmployee.showWorkScheduleEmployee(id)
                .then(res => {
                    commit("GET_WORK_SCHEDULE_BY_ID", res);
                })
        },
        saveWorkSchedule({commit}, {id, data}) {
            if (!id) {
                return Service.WorkScheduleEmployee.createWorkScheduleEmployee(data)
                    .then(res => {
                        commit("GET_WORK_SCHEDULE_BY_ID", res);
                    })
            } else {
                return Service.WorkScheduleEmployee.updateWorkScheduleEmployee(id, data)
                    .then(res => {
                        commit("GET_WORK_SCHEDULE_BY_ID", res);
                    })
            }
        },
        showWorkScheduleByEmployee({commit}, data) {
            let id = data.hasOwnProperty('employee_id') ? data.employee_id : data;
            let page = data.hasOwnProperty('page') ? data.page : 1;
            return Service.WorkScheduleEmployee.showWorkScheduleByEmployee(id, page).then(res => {
                commit("GET_WORK_SCHEDULE_BY_EMPLOYEE", res);
                Service.WorkScheduleEmployee.showVocationDay(id).then(res2 => {
                    commit("SET_VOCATION_DAY", res2);
                })
            });
        },
        delete({commit}, id) {
            return Service.WorkScheduleEmployee.deleteWorkScheduleEmployee(id);
        },
        searchEmployeeWorkSchedule({commit}, data) {
            return Service.WorkScheduleEmployee.searchEmployeeWorkSchedule(data).then(res => {
                commit("GET_WORK_SCHEDULE_EMPLOYEE", res);
            })
        },
        clearData({commit}, employee) {
            commit("CLEAR_DATA", employee)
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        }
    }
};
export default WorkScheduleEmployee;
